<!-- Form select sort by -->
<form class="form-sort filter-results-header-option" id="grid-sort">
    <span class="form-item-select">
        <span class="form-item-select-label-wrapper">
            <label class="form-sort-label" [attr.for]="'result-sort-by'" i18n="@@hermes-search-result.sort-by">
                Sort by
            </label>

            <select
                id="result-sort-by"
                name="sortby"
                [attr.aria-describedby]="'refresh-grid-notify'"
                [formControl]="sortControl">
                @for (sortOption of sortOptions; track trackBySortOption($index, sortOption)) {
                <option [attr.selected]="selectedValue === sortOption.sort ? true : undefined" [ngValue]="sortOption">
                    {{ sortOption.label }}
                </option>
                }
            </select>

            <!-- access notifyer -->
            <p
                id="refresh-grid-notify"
                class="sr-only"
                [attr.aria-hidden]="'true'"
                i18n="@@hermes.accessibility.refresh_grid">
                Select item will refresh the gallery below
            </p>

            <!--  Selected sort to display to user, native select input is hidden behind this span -->
            <span class="current-sort" [attr.aria-hidden]="'true'">
                {{ sortControl.value.label }}
            </span>
        </span>

        <span class="svg">
            <h-svg-icon [name]="'arrow-down'"></h-svg-icon>
        </span>
    </span>
</form>
